import { Component, OnInit, Input, Output, EventEmitter, Inject } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import * as sweetalert from 'sweetalert';
import { Sort, MatDialog,MatDialogRef,MAT_DIALOG_DATA } from '@angular/material';
import { UUID } from 'angular2-uuid';



import { GlobalsService } from '../services/globals.service';
import { UtilesService } from '../services/utiles.service';
import { ViajeService } from '../services/viaje.service';
import { Viaje } from '../Models/Viaje';
import { ViajeVisita } from '../Models/ViajeVisita';
import { forEach } from '@angular/router/src/utils/collection';
import { Timeouts } from 'selenium-webdriver';

@Component({
  selector: 'app-viaje',
  templateUrl: './viaje.component.html',
  styleUrls: ['./viaje.component.css']
})
export class ViajeComponent implements OnInit {



  public viaje: Viaje = new Viaje();
  public viajes: Viaje[];

  public modoEdicion: boolean = false;
  public nuevoRegistro: boolean = false;

  constructor(private viajeService: ViajeService, private globalServices: GlobalsService, private utilService: UtilesService) {}


  ngOnInit() {
  }


  // openDialog(): void {
  //   let dialogRef = this.dialog.open(DialogOverviewExampleDialog, {
  //     width: '250px',
  //     data: { name: this.name, animal: this.animal }
  //   });

  //   dialogRef.afterClosed().subscribe(result => {
  //     console.log('The dialog was closed');
  //     this.animal = result;
  //   });
  // }



}

// export class DialogOverviewExampleDialog {

//   constructor(
//     public dialogRef: MatDialogRef<DialogOverviewExampleDialog>,
//     @Inject(MAT_DIALOG_DATA) public data: any) { }

//   onNoClick(): void {
//     this.dialogRef.close();
//   }

// }

